// CO2-Monitor-Liste fuer /zuhause/co2monitor + /zuhause/sensoren (History
// bleibt page-lokal, eigener Endpoint mit hours-Parameter).
//
// Datenfluss: kein eigener Abruf mehr -- die Liste kommt aus dem gemeinsamen
// Sensoren-Stand (lib/sensoren.svelte.ts), den das Homelab-Protokoll (Topic
// sensor.stand, docs/protokoll.md › „Sensoren über das Protokoll“) speist.
// REST nur beim Start, als Revalidator, nach Aktionen und als Neuversuch --
// dort. Bis 02.11.2026 holte dieser Store alle 30 s (und bei jedem WS-Signal
// "co2monitor") GET /v2-api/co2monitor.

import { getCo2Geraete, refreshSensoren, startSensoren } from "./sensoren.svelte";
import type { Co2MonitorDevice } from "./types";

let _aus: (() => void) | undefined;

export function startCo2Summary(): void {
  if (_aus) return;
  _aus = startSensoren();
}

export function stopCo2Summary(): void {
  _aus?.();
  _aus = undefined;
}

export function getCo2Summary(): Co2MonitorDevice[] | undefined {
  return getCo2Geraete();
}

export async function refreshCo2Summary(): Promise<void> {
  await refreshSensoren("co2");
}
